import { useState } from "react";
import UserInfo from "../../../Form/UserInfo";
import "./CardAccordion.css";
import calculateCalories from "./CalculateCalories";
import AccordionBlock from "./AccordionBlock/AccordionBlock";
import { InputElement, SelectElement } from "./AccordionBlock/FormElements";
import {
  activitySelectorOptions,
  ageSelectorOptions,
  breastfeedingAmountSelectorOptions,
  breastfeedingTimeSelectorOptions,
  pregnancyBreastfeedingSelectorOptions,
  sexSelectorOptions,
  trimesterSelectorOptions,
} from "../SelectorValues/SelectorValue";
import BlockResult from "./AccordionBlock/BlockResult/BlockResult";

function CardAccordion(props: {
  userDetails: UserInfo;
  setUserDetails: React.Dispatch<React.SetStateAction<UserInfo>>;
}) {
  const { userDetails, setUserDetails } = props;

  const [currentStep, setCurrentStep] = useState(1);

  let ageGroup: string | undefined = undefined;

  function finalResults() {
    let ageGroup: string;

    if (userDetails.age) {
      if (userDetails.age < 2) {
        ageGroup = "0-1";
      } else if (userDetails.age < 4) {
        ageGroup = "2-3";
      } else if (userDetails.age < 9) {
        ageGroup = "4-8";
      } else if (userDetails.age < 14) {
        ageGroup = "9-13";
      } else {
        ageGroup = "14-99";
      }
      window.location.href = `/${ageGroup}/${userDetails.finalCalories}`;
    }
  }

  function stepFinished() {
    requestAnimationFrame(() => {
      const form = document.getElementById("form");
      if (form) {
        form.scrollIntoView({ block: "start" });
        let backgroundPosition =
          parseFloat(form.style.backgroundPositionY) || 0;
        backgroundPosition += 12.5;
        form.style.backgroundPositionY = backgroundPosition + "%";
      }
    });

    //#endregion
    if (userDetails.age && userDetails.age <= 2) {
      switch (userDetails.age) {
        case 1:
          userDetails.finalCalories.overall = 800;
          break;
        case 1.25:
          userDetails.finalCalories.overall =
            userDetails.sex === "male" ? 900 : 800;
          break;
        case 1.5:
          userDetails.finalCalories.overall =
            userDetails.sex === "male" ? 1000 : 900;
          break;
        default:
          userDetails.finalCalories.overall = 1000;
      }
      userDetails.finalCalories.maintain = undefined;
      userDetails.finalCalories.achieveHealthy = undefined;
      setCurrentStep(7);
      return;
    }
    //#endregion
    //#region 2-8 years - first, we determine sex and then activity level
    else if (userDetails.age && userDetails.age <= 8) {
      if (userDetails.activityLevel === undefined) {
        if (userDetails.sex === "male")
          switch (userDetails.age) {
            case 2:
              userDetails.low = 1000;
              userDetails.mid = 1000;
              userDetails.high = 1000;
              break;
            case 3:
              userDetails.low = 1000;
              userDetails.mid = 1400;
              userDetails.high = 1400;
              break;
            case 4:
              userDetails.low = 1000;
              userDetails.mid = 1400;
              userDetails.high = 1400;
              break;
            case 5:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1600;
              break;
            case 6:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1600;
              break;
            case 7:
              userDetails.low = 1400;
              userDetails.mid = 1600;
              userDetails.high = 1800;
              break;
            case 8:
              userDetails.low = 1400;
              userDetails.mid = 1600;
              userDetails.high = 2000;
              break;
            default:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1600;
              break;
          }
        else
          switch (userDetails.age) {
            case 2:
              userDetails.low = 1000;
              userDetails.mid = 1000;
              userDetails.high = 1000;
              break;
            case 3:
              userDetails.low = 1000;
              userDetails.mid = 1200;
              userDetails.high = 1400;
              break;
            case 4:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1400;
              break;
            case 5:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1400;
              break;
            case 6:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1600;
              break;
            case 7:
              userDetails.low = 1200;
              userDetails.mid = 1600;
              userDetails.high = 1800;
              break;
            case 8:
              userDetails.low = 1400;
              userDetails.mid = 1600;
              userDetails.high = 1800;
              break;
            default:
              userDetails.low = 1200;
              userDetails.mid = 1400;
              userDetails.high = 1400;
              break;
          }
        setCurrentStep(6);
        return;
      } else {
        userDetails.finalCalories.overall =
          userDetails[userDetails.activityLevel];
        userDetails.finalCalories.maintain = undefined;
        userDetails.finalCalories.achieveHealthy = undefined;
        setCurrentStep(7);
        return;
      }
    }
    //#endregion
    //#region Age over 8 years
    else {
      //#region Women 14-50
      if (
        userDetails.age &&
        userDetails.age >= 14 &&
        userDetails.age <= 50 &&
        userDetails.sex === "female"
      ) {
        if (userDetails.pregnantOrBreastFeeding === undefined) {
          setCurrentStep(3);
          return;
        }
        if (userDetails.pregnantOrBreastFeeding !== "none") {
          if (userDetails.pregnantOrBreastFeeding === "pregnant") {
            userDetails.pregnant = true;
          } else {
            userDetails.breastfeeding = true;
          }
          if (
            userDetails.pregnant === true &&
            userDetails.pregnancyTrimester === undefined
          ) {
            setCurrentStep(4);
            return;
          } else if (
            userDetails.breastfeeding === true &&
            userDetails.breastfeedingAmount === undefined &&
            userDetails.breastfeedingTime === undefined
          ) {
            setCurrentStep(5);
            return;
          }
        }
        if (
          userDetails.weight === undefined &&
          userDetails.height === undefined
        ) {
          setCurrentStep(2);
          return;
        } else if (userDetails.activityLevel === undefined) {
          setCurrentStep(6);
          return;
        } else {
          userDetails.finalCalories = calculateCalories(userDetails);
          setCurrentStep(7);
          return;
        }
      }
      //#endregion
      //#region Men over 8
      else {
        if (
          userDetails.weight === undefined &&
          userDetails.height === undefined
        ) {
          setCurrentStep(2);
          return;
        } else if (userDetails.activityLevel === undefined) {
          setCurrentStep(6);
          return;
        } else {
          userDetails.finalCalories = calculateCalories(userDetails);
          setCurrentStep(7);
          return;
        }
      }
      //#endregion
    }
    //#endregion
  }
  //#region Selectors and inputs
  //#region First section button
  const [stepOneFirstSelection, setStepOneFirstSelection] = useState(false);
  const ageSelector: SelectElement = {
    type: "select",
    id: "age-select",
    label: "ასაკი",
    options: ageSelectorOptions,
    changeSubject: "age",
    onChange: {
      data: setUserDetails,
      buttonState: stepOneFirstSelection,
      button: setStepOneFirstSelection,
    },
  };

  const [stepOneSecondSelection, setStepOneSecondSelection] = useState(false);
  const sexSelector: SelectElement = {
    type: "select",
    id: "sex-select",
    label: "სქესი",
    options: sexSelectorOptions,
    changeSubject: "sex",
    onChange: {
      data: setUserDetails,
      buttonState: stepOneSecondSelection,
      button: setStepOneSecondSelection,
    },
  };
  const isFirstButtonDisabled = !(
    stepOneFirstSelection && stepOneSecondSelection
  );
  //#endregion

  //#region Second section button
  const [heightValue, setHeightValue] = useState<number | undefined>(undefined);
  const [weightValue, setWeightValue] = useState<number | undefined>(undefined);

  const [heightWarning, setHeightWarning] = useState<boolean>(false);
  const [weightWarning, setWeightWarning] = useState<boolean>(false);

  const minHeight: number = 100;
  const maxHeight: number = 300;
  const minWeight: number = 14;
  const maxWeight: number = 630;

  const isHeightValid =
    typeof heightValue === "number" && heightValue >= 100 && heightValue <= 300;
  const isWeightValid =
    typeof weightValue === "number" && weightValue >= 14 && weightValue <= 630;

  const isSecondButtonDisabled = !(isHeightValid && isWeightValid);

  // Height Validation
  const handleHeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value =
      e.target.value === undefined ? undefined : parseInt(e.target.value, 10);
    setHeightValue(value);

    if (typeof value === "number" && value >= 100 && value <= 300) {
      setUserDetails((prev) => ({ ...prev, height: value }));
    }
  };

  // Weight Validation
  const handleWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value =
      e.target.value === undefined ? undefined : parseInt(e.target.value, 10);
    setWeightValue(value);

    if (typeof value === "number" && value >= 14 && value <= 630) {
      setUserDetails((prev) => ({ ...prev, weight: value }));
    }
  };

  const heightInput: InputElement = {
    id: "height-input",
    type: "number",
    label: "სიმაღლე (სმ)",
    min: minHeight,
    max: maxHeight,
    warning: heightWarning,
    warningToggle: setHeightWarning,
    warningMessage: `სიმაღლის დასაშვები ზღვარია ${minHeight} - ${maxHeight} სმ`,
    changeSubject: "height",
    value: heightValue,
    onChange: handleHeightChange,
  };

  const weightInput: InputElement = {
    id: "weight-input",
    type: "number",
    label: "წონა (კგ)",
    min: minWeight,
    max: maxWeight,
    warning: weightWarning,
    warningToggle: setWeightWarning,
    warningMessage: `წონის დასაშვები ზღვარია ${minWeight} - ${maxWeight} კგ`,
    changeSubject: "weight",
    value: weightValue,
    onChange: handleWeightChange,
  };
  //#endregion

  //#region Third section button
  const [stepThreeFirstSelection, setStepThreeFirstSelection] = useState(false);
  const womanStateSelector: SelectElement = {
    type: "select",
    id: "woman-state-select",
    options: pregnancyBreastfeedingSelectorOptions,
    changeSubject: "pregnantOrBreastFeeding",
    onChange: {
      data: setUserDetails,
      buttonState: stepThreeFirstSelection,
      button: setStepThreeFirstSelection,
    },
  };

  const isThirdButtonDisabled = !stepThreeFirstSelection;
  //#endregion

  //#region Fourth section button
  const [stepFourFirstSelection, setStepFourFirstSelection] = useState(false);
  const pregnancyTrimesterSelector: SelectElement = {
    type: "select",
    id: "trimester-select",
    options: trimesterSelectorOptions,
    changeSubject: "pregnancyTrimester",
    onChange: {
      data: setUserDetails,
      buttonState: stepFourFirstSelection,
      button: setStepFourFirstSelection,
    },
  };

  const isFourthButtonDisabled = !stepFourFirstSelection;
  //#endregion

  //#region Fifth section button
  const [stepFiveFirstSelection, setStepFiveFirstSelection] = useState(false);
  const breastFeedingAmountSelector: SelectElement = {
    type: "select",
    id: "breastfeeding-amount-select",
    label: "ლაქტაციის ტიპი",
    options: breastfeedingAmountSelectorOptions,
    changeSubject: "breastfeedingAmount",
    onChange: {
      data: setUserDetails,
      buttonState: stepFiveFirstSelection,
      button: setStepFiveFirstSelection,
    },
  };

  const [stepFiveSecondSelection, setStepFiveSecondSelection] = useState(false);
  const breastFeedingTimeSelector: SelectElement = {
    type: "select",
    id: "breastfeeding-time-select",
    label: "ლაქტაციის ხანგრძლივობა",
    options: breastfeedingTimeSelectorOptions,
    changeSubject: "breastfeedingTime",
    onChange: {
      data: setUserDetails,
      buttonState: stepFiveSecondSelection,
      button: setStepFiveSecondSelection,
    },
  };

  const isFifthButtonDisabled = !(
    stepFiveFirstSelection && stepFiveSecondSelection
  );
  //#endregion

  //#region Sixth section button
  const [stepSixFirstSelection, setStepSixFirstSelection] = useState(false);
  const activityLevelSelector: SelectElement = {
    type: "select",
    id: "activity-level-select",
    label: "დღეში:",
    options: activitySelectorOptions,
    changeSubject: "activityLevel",
    onChange: {
      data: setUserDetails,
      buttonState: stepSixFirstSelection,
      button: setStepSixFirstSelection,
    },
  };

  const isSixthButtonDisabled = !stepSixFirstSelection;
  //#endregion

  return (
    <div className="card-accordion df fdc aic jcsb">
      {currentStep === 1 && (
        <AccordionBlock
          header="ასაკი & სქესი"
          paragraph="გთხოვთ მოგვაწოდოთ სწორი ინფორმაცია ზუსტი შედეგის მისაღებად"
          elements={[ageSelector, sexSelector]}
          buttonAction={stepFinished}
          needsNextButton={true}
          buttonDisabled={isFirstButtonDisabled}
        />
      )}
      {currentStep === 2 && (
        <AccordionBlock
          header="სიმაღლე & წონა"
          elements={[heightInput, weightInput]}
          buttonAction={stepFinished}
          needsNextButton={true}
          buttonDisabled={isSecondButtonDisabled}
        />
      )}
      {currentStep === 3 && (
        <AccordionBlock
          header="ორსულობა და ძუძუთი კვება"
          paragraph="აირჩიეთ თქვენთვის შესაბამისი მდგომარეობა"
          elements={[womanStateSelector]}
          buttonAction={stepFinished}
          needsNextButton={true}
          buttonDisabled={isThirdButtonDisabled}
        />
      )}
      {currentStep === 4 && (
        <AccordionBlock
          header="ორსულობა"
          paragraph="აირჩიეთ ტრიმესტრი"
          elements={[pregnancyTrimesterSelector]}
          buttonAction={stepFinished}
          needsNextButton={true}
          buttonDisabled={isFourthButtonDisabled}
        />
      )}
      {currentStep === 5 && (
        <AccordionBlock
          header="ძუძუთი კვება / ლაქტაცია"
          elements={[breastFeedingAmountSelector, breastFeedingTimeSelector]}
          buttonAction={stepFinished}
          needsNextButton={true}
          buttonDisabled={isFifthButtonDisabled}
        />
      )}
      {currentStep === 6 && (
        <AccordionBlock
          header="ფიზიკური აქტივობა"
          elements={[activityLevelSelector]}
          buttonAction={stepFinished}
          needsNextButton={true}
          buttonDisabled={isSixthButtonDisabled}
        />
      )}
      {currentStep === 7 && (
        <BlockResult
          paragraph="მონაცემებზე დაყრდნობით, თქვენი კალორიული გეგმა გამოიყურება შემდეგნაირად:"
          footer="დეტალების სანახავად დააკლიკეთ შესაბამის კალორიულ გეგმას"
          caloriesResult={userDetails.finalCalories}
          userDetails={userDetails}
        />
      )}
    </div>
  );
}

export default CardAccordion;
